"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4.14 2.69c-.39.39-.39 1.02 0 1.41l9.67 9.67-1.41 1.41-3.54-3.53a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.24 4.24c.39.39 1.02.39 1.41 0l2.12-2.12 5.89 5.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.55 2.69a.9959.9959 0 0 0-1.41 0m13.91 9.67 4.24-4.24c.39-.39.39-1.03-.01-1.42-.39-.38-1.02-.38-1.41.01l-4.24 4.24zM16.64 6.7a.9959.9959 0 0 0-1.41 0l-1.42 1.42 1.41 1.41 1.42-1.42c.39-.39.39-1.02 0-1.41M1.79 13.06l4.95 4.95 1.41-1.41-4.95-4.95a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41"
}), 'RemoveDoneRounded');